"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAssistedLoginRoute = exports.isDevelopmentLogicCCRoute = exports.isDRPicasoRoute = exports.createNavigationId = exports.createInteractionId = exports.generateHash = exports.isContactCenter = void 0;
const isContactCenter = () => {
    return !!window.COUNTRY && window.COUNTRY.includes('cc');
};
exports.isContactCenter = isContactCenter;
const INTERACTION_ID_CHARS = '0123456789abcdef';
const INTERACTION_ID_LENGTH = 12;
const NAVIGATION_ID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const NAVIGATION_ID_LENGTH = 16;
const generateHash = (length = INTERACTION_ID_LENGTH, characters = INTERACTION_ID_CHARS) => {
    let hash = '';
    for (let i = 0; i < length; i += 1) {
        hash += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return hash;
};
exports.generateHash = generateHash;
const createInteractionId = () => (0, exports.generateHash)();
exports.createInteractionId = createInteractionId;
const createNavigationId = () => (0, exports.generateHash)(NAVIGATION_ID_LENGTH, NAVIGATION_ID_CHARS);
exports.createNavigationId = createNavigationId;
const hasRequiredAzureNavigation = () => window.location.href.includes('#code=');
const isDRPicasoRoute = () => window.location.href.includes('dr-agent-login') || hasRequiredAzureNavigation();
exports.isDRPicasoRoute = isDRPicasoRoute;
const isDevelopmentLogicCCRoute = () => window.location.pathname.endsWith('/login');
exports.isDevelopmentLogicCCRoute = isDevelopmentLogicCCRoute;
const isAssistedLoginRoute = () => window.location.href.includes('/assisted-login');
exports.isAssistedLoginRoute = isAssistedLoginRoute;
//# sourceMappingURL=index.js.map